module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-5.0c4c78a6.jpg";